import React, { useEffect, useState, useRef, useCallback } from 'react'
import { useNavigate } from "react-router-dom"
import CardItem from '../../Shared/CardItem'
import CollectionCardItem from '../../Shared/CollectionCardItem'
import { ProfilePanel } from '../ProfilePanel'
import { ProfilePageSections } from '../index'
import ActivitySection from '../../Shared/ActivitySection'
import OfferSection from '../../Shared/OfferSection'
import Notifications from '../../Shared/Notifications'
import { EmptyFolderIcon } from '../../Shared/SvgIcons'
import GradientButton from '../../Shared/GradientButton'
import HideNFTSection from '../../Shared/HideNFTSection'
import FavoriteSection from '../../Shared/FavoriteSection'
import { useCustomWallet } from '../../../contexts/WalletContext'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useAuth, UserRole } from '../../../contexts/AuthContext'
import { Select } from '../../Shared/Select'
import { useData } from '../../../contexts/DataContext'
import AuctionSection from '../../Shared/AuctionSection'
import ListingSection from '../../Shared/ListingSection'
import { METHOD_TYPE } from '../../../global/const'
import useToast from '../../../hooks/useToast'
import {
  MainContentContainer,
  CardContainer,
  CardList,
  FilterWrapper,
  Option,
  SelectWrapper
} from './styles'
import { CollectionPanel } from '../CollectionPanel'
import STATUS from '../../../global/const'

const PIXELS_TO_SCROLL = 100;

export const MainContent = (props) => {
  const {
    address,
    isMoreView,
    activeSection,
    handleActiveSection,
    isProfile
  } = props

  let navigate = useNavigate()
  const gridDivRef = useRef()
  const { wallet } = useCustomWallet()
  const { auth } = useAuth()
  const { invokeServer } = useGlobal()
  const { searchText } = useData()
  const { showLoading, hideLoading } = useToast()

  const [nftList, setNftList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadMore, setIsLoadMore] = useState(false);
  const [paginationProps, setPaginationProps] = useState({
    page_size: 15,
    current_page: 1
  })
  const [isOperator, setIsOperator] = useState(false)
  const [ownerInfo, setOwnerInfo] = useState({
    items: 0,
    holders: 0,
    floorPrice: 0.0,
    volumeTrade: 0.0,
  })
  const [collectionInfo, setCollectionInfo] = useState({})
  const [selectedMethod, setSelectedMethod] = useState(METHOD_TYPE.DIRECT_SALE)

  const containerRef = useRef(null)

  const tokenOptions = [
    { value: METHOD_TYPE.DIRECT_SALE, content: <Option><span>Direct Sale</span></Option> },
    { value: METHOD_TYPE.AUCTION, content: <Option><span>Auction</span></Option> },
    { value: METHOD_TYPE.UNLISTED, content: <Option><span>Unlisted</span></Option> },
  ]

  const handleDetails = (item) => {
    if (item?.method === 0) navigate(`/products/${item.collectionAddress}/${item.tokenId}/${item.saleId}/buy`)
    else if (item?.method === 1) navigate(`/products/${item.collectionAddress}/${item.tokenId}/${item.saleId}/bid`)
    else navigate(`/products/${item.collectionAddress}/${item.tokenId}/` + (isOperator? 'sale' : 'offer'))
  }

  useEffect(() => {
    setIsOperator(t => wallet.address.toLowerCase() === address.toLowerCase());
  }, [wallet.address, address])

  useEffect(() => {
    let ac = new AbortController();
    if (isProfile) {
      invokeServer('get', `/api/user?address=${address}`)
      .then(res => {
        if (ac.signal.aborted === false) {
          if (res.data.result === 1) {
            let j;
            let rr = res.data.user;
            setOwnerInfo(t => { return { ...t, ...rr } })
          }
        }
      })
      .catch(err => {
        console.log(`${err.message}`);
      })
    } else {
      invokeServer('get', `/api/collection?owner=&extra=one&address=${address}`)
        .then(res => {
          if (res.data.status === STATUS.OK) {
            setCollectionInfo(res.data.data[0]);
          } else {
            console.log('Warning', res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        })
    }
    return () => ac.abort();
  }, [address])

  const handleBuyNewItem = () => {
    navigate('/explorer');
  }

  const handleCreateNewItem = () => {
    navigate('/upload');
  }

  const getNftList = useCallback((page, page_size, newFetch = false) => {
    if (newFetch) setIsLoading(true)
    else setIsLoadMore(true)
    let params = isProfile
      ? `method=${selectedMethod}&address=${address}&page=${page}&page_size=${page_size}`
      : `method=${selectedMethod}&collection=${address}&page=${page}&page_size=${page_size}`

    invokeServer('get', `/api/nft?${params}`)
      .then(res => {
        if (!res.data.error) {
          if (newFetch) setNftList(res.data.result)
          else setNftList([...nftList, ...res.data.result])
          setPaginationProps(res.data.pagination)
        } else {
          console.log(res.data.result)
        }
        if (newFetch) setIsLoading(false)
        else setIsLoadMore(false)
      })
      .catch(err => {
        if (newFetch) setIsLoading(false)
        else setIsLoadMore(false)
        console.log(err)
      })
  }, [nftList, address, selectedMethod, invokeServer, searchText])

  useEffect(() => {
    getNftList(1, paginationProps.page_size, true)
  }, [selectedMethod, address, searchText])

  const handleScroll = useCallback(() => {
    if (isLoadMore) return;

    const innerHeightScrolltop =
      containerRef?.current.offsetHeight +
      containerRef?.current.scrollTop +
      PIXELS_TO_SCROLL;
      if (containerRef?.current.scrollHeight < innerHeightScrolltop && paginationProps.current_page <= paginationProps.total_pages) {
        getNftList(paginationProps.current_page + 1, paginationProps.page_size)
      }
  }, [isLoadMore, paginationProps, getNftList])

  useEffect(() => {
    containerRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      containerRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll])

  useEffect(() => {
    if (isLoading) {
      showLoading(`Loading...`)
    } else {
      hideLoading()
    }
  }, [isLoading])

  const renderMainContent = () => {
    switch (activeSection) {
      case ProfilePageSections.grid:
        return (
          <>
            <FilterWrapper>
              <SelectWrapper>
                <Select
                  notReload
                  placeholder='Select a option'
                  options={tokenOptions}
                  defaultValue={selectedMethod}
                  onChange={val => setSelectedMethod(val)}
                />
              </SelectWrapper>
            </FilterWrapper>
            <CardList isMoreView={isMoreView} ref={gridDivRef}>
              {!isLoading && nftList?.length > 0 && nftList.map((item, i) => (
                <React.Fragment key={i}>
                  {isProfile ? (
                    <CardItem
                      item={item}
                      onClick={() => handleDetails(item)}
                    />
                  ) : (
                    <CollectionCardItem
                      item={item}
                      onClick={() => handleDetails(item)}
                    />
                  )}
                </React.Fragment>
              ))}
               {isLoadMore && [...Array(8).keys()].map((i) => (
                 <React.Fragment key={i}>
                   {isProfile ? <CardItem key={i} isSkeleton /> : <CollectionCardItem key={i} isSkeleton />}
                 </React.Fragment>
                ))}
            </CardList>
            {!isLoading && nftList?.length === 0 && (
              <div className="no-result" ref={gridDivRef}>
                <EmptyFolderIcon />
                <div className="empty-text">There are no NFTs in {isOperator === true ? 'your' : `${address}'s`} portfolio Yet</div>
                {
                  isOperator ?
                    <div className="action-buttons">
                      {
                        auth.loggedUserRole === UserRole.Creator ?
                          <GradientButton
                            label={'Create item'}
                            height={'36px'}
                            width={'106px'}
                            fontSize={'14px'}
                            handleClick={handleCreateNewItem}
                          /> : <></>
                      }
                      <GradientButton
                        label={'Buy new item'}
                        height={'36px'}
                        width={'106px'}
                        fontSize={'14px'}
                        handleClick={handleBuyNewItem}
                      />
                    </div> : <></>
                }
              </div>
            )}
          </>
        )
      case ProfilePageSections.activity:
        return (
          <div className="activity-section">
            <ActivitySection
              handleActiveSection={handleActiveSection}
              userAddress={address}
            />
          </div>
        )
      case ProfilePageSections.offer:
        return (
          <div className="offer-section">
            <OfferSection
              userAddress={address}
            />
          </div>
        )
      case ProfilePageSections.notifications:
      return (
        <div className="offer-section">
          <Notifications
            handleActiveSection={handleActiveSection}
            userAddress={address}
          />
        </div>
      )
      case ProfilePageSections.auction:
      return (
        <div className="offer-section">
          <AuctionSection
            userAddress={address}
            handleActiveSection={handleActiveSection}
          />
        </div>
      )
      case ProfilePageSections.listing:
        return (
          <div className="offer-section">
            <ListingSection handleActiveSection={handleActiveSection} userAddress={address} />
          </div>
        )
      case ProfilePageSections.hideNFT:
        return (
          <div className="hideNft-section">
            <HideNFTSection />
          </div>
        )
      case ProfilePageSections.favorite:
        return (
          <div className="favorite-section">
            <FavoriteSection address={address} />
          </div>
        )
      default:
        break;
    }
  }

  return (
    <MainContentContainer>
      {isProfile ? (
        <ProfilePanel ownerInfo={ownerInfo} isProfile={isProfile} />
      ) : (
        <CollectionPanel collectionInfo={collectionInfo} />
      )}
      <CardContainer ref={containerRef}>
        {renderMainContent()}
      </CardContainer>
    </MainContentContainer>
  )
}